<template>
    <div>
        <div class="pay-wrap">
            <div class="content">
                <p class="pay-tips"> 付款成功后请勿关闭此页面，请耐心等待自动回调订单，否则可能无法自动到账!</p>

                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">商品订单</span>
                        <span class="text">{{ detail.orderNo }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">商品详情</span>
                        <span class="text">{{ detail.title }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">购买数量</span>
                        <span class="text">{{ detail.inputNumber }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ detail.price * detail.inputNumber }}USDT</span>
                    </div>
                    <div class="info-list">
                        <span class="label">充值账号</span>
                        <span class="text">{{ detail.inputGT }}</span>
                    </div>
                </div>

                <div class="pay-list">
                    <p class="title">选择付款钱包</p>
                    <div v-for="(item, index) in payList" :key="index" class="item">
                        <div class="img-wrap">
                            <img :src="item.src" alt="">
                            <span class="title">{{ item.title }}</span>
                        </div>
                        <a-radio-group v-model:value="checkedVal">
                            <a-radio :value="item.value"></a-radio>
                        </a-radio-group>
                    </div>
                    <div class="btn-wrap">
                        <a-button class="btn" @click="onPay" type="primary">打开支付</a-button>
                    </div>
                </div>
            </div>
        </div>
         <!-- 二维码弹窗 -->
         <a-modal v-model:visible="qrVisible" title="比特派钱包支付" @ok="qrVisible = false" @cancel="qrVisible = false">
            <div class="qr-modal-content">
                <p class="qr-tips">请使用比特派钱包扫描下方二维码完成支付</p>
                <div class="qr-code-wrapper">
                    <canvas ref="qrCanvas"></canvas>
                </div>
                <p class="qr-tips">或复制以下链接到比特派钱包中打开:</p>
                <a-input v-model:value="bitpieUrl" readonly class="qr-input">
                    <template #addonAfter>
                        <a-button type="text" @click="copyUrl">复制</a-button>
                    </template>
                </a-input>
            </div>
        </a-modal>
    </div>
</template>

<script>
// import { testTX } from '../util/tronweb'; 
// import { getBuildRawTransaction } from "../util/api"
import QRCode from 'qrcode';

export default {
    name: 'PaymentPage',
    props: {
        msg: String
    },
    components: {
    },
    data() {
        return {
            detail: {},
            checkedVal: '',
            referralCode:'',
            tgNo:'',
            qrVisible: false,
            bitpieUrl: '',
            payList: [
                { title: 'imToken钱包', src: require('../assets/imtoken.jpg'), value: 'imtoken', checked: false },
                { title: 'Tokenpocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket', checked: true },
                { title: 'BitGet钱包', src: require('../assets/bitget.jpg'), value: 'bitget', checked: false },
                { title: 'TronLink钱包', src: require('../assets/tronlink.jpg'), value: 'tronlink', checked: false },
                // { title: '比特派钱包', src: require('../assets/biep.png'), value: 'bitpie', checked: false },
            ]
        }
    },
    mounted() {
        
        const data = JSON.parse(this.$route.params.data); // 解析字符串为对象
        this.detail = data
        const referralCode = data.referral_code;
        console.log(data)
        this.referralCode = referralCode;
        this.tgNo = data.inputGT;

        

        if (window.tronWeb && window.tronWeb.ready) {
            console.log("✅ TronLink 发现！");
            //this.$router.push({ name: 'walletPay', params: { tgNo: this.tgNo,referralCode:this.referralCode } });
            this.$router.push({ 
                path: `/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}` 
            });
            
        } else {
            console.error("❌ 未安装 TronLink");
        }

    },
    methods: {
        getUserApploenMethod() {
            // 
        },
        onCheck(val) {
            this.checkedVal = val
        },
        async onPay() {
            
    
             // 1. 检查是否拥有 TronLink 注入
             // 根据钱包的选择链接到不同的钱包
            //添加订单

           // const dynamicPath = `http://127.0.0.1:1024/walletPay/tgNo/${encodeURIComponent(this.tgNo)}/referralCode/${encodeURIComponent(this.referralCode)}`;
              
            if (this.checkedVal == 'imtoken') {
                // 生成动态路径参数的 URL
               // 构建深链接
                const dynamicPath = `https://client.dcetnu.top/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}`;
               //const dynamicPath = "https://www.google.com/"
               const deeplink = `imtokenv2://navigate/DappView?url=${dynamicPath}`;
                console.log(deeplink);
                // 跳转
                window.location.href = deeplink;
            }else if(this.checkedVal == 'tokenpocket'){
                const dynamicPath = `https://client.dcetnu.top/walletPay/tgNo/${encodeURIComponent(this.detail.orderNo)}/referralCode/${encodeURIComponent(this.referralCode)}`;
                //const dynamicPath = "https://www.google.com/"
                console.log(dynamicPath)
                let param = {}
                param = {
                "url":dynamicPath,
                "chain": "Tron",
                "source": "shopSer"
                }

            // 2. 将对象转为JSON字符串后再进行URL编码
                const encodedParam = encodeURIComponent(JSON.stringify(param),"utf-8");

                //const deeplink = `tpoutside://pull.activity?param=${encodedParam}`;
                const deeplink = `tpdapp://open?params=${encodedParam}`;
                console.log(deeplink);
                // 跳转
                window.location.href = deeplink;
                
            }else if(this.checkedVal == 'bitget'){  
                const dynamicPath = `https://client.dcetnu.top/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}`;
                           
                const deeplink = `https://bkcode.vip?action=dapp&url=${dynamicPath}`
                // 跳转
                window.location.href = deeplink;
               
            }else if(this.checkedVal == 'tronlink'){
               const dynamicPath = `https://client.dcetnu.top/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}`;
              // const dynamicPath = `https://xiaotiankfbot.com:8443/walletPay/tgNo/888835/referralCode/${encodeURIComponent(this.referralCode)}`;
             
            // 1. 将对象转为JSON字符串
                // 2. 进行URL编码
                    // 只需要对你的目标 URL 进行编码即可
                const encodedUrl = encodeURIComponent(dynamicPath);
                // 使用标准的 tronlinkapp 协议
                const deeplink = `tronlinkapp://open?url=${encodedUrl}`;
                // 跳转
                 window.location.href = deeplink;
            }else if(this.checkedVal == 'bitpie'){
                this.bitpieUrl = `https://client.dcetnu.top/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}`;

                 // 显示二维码弹窗
                 this.qrVisible = true;
                
                // 生成二维码
                this.$nextTick(() => {
                    QRCode.toCanvas(this.$refs.qrCanvas, this.bitpieUrl, {
                        width: 200,
                        margin: 2
                    }, (error) => {
                        if (error) console.error(error);
                    });
                });
            }
            // 登录后获取当前钱包地址
           
            //getUserApploen();
            //getUserApploen()
            // this.getUserApploenMethod()
        },
        copyUrl() {
            navigator.clipboard.writeText(this.bitpieUrl).then(() => {
                this.$message.success('链接已复制到剪贴板');
            }).catch(err => {
                console.error('复制失败:', err);
                this.$message.error('复制失败');
            });
        }
    }
}
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .tips {
            padding: 20px 0px 10px;
            line-height: 22px;
            margin-bottom: 0;
            font-size: 16px;
            text-align: center;
        }

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;

            .title {
                font-weight: bold;
            }

            .item {
                display: flex;
                align-items: center;
                height: 60px;
                justify-content: space-between;
                border-bottom: #f8f8f8 2px solid;
            }

            .img-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    margin-right: 16px;
                }
            }
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                width: 100%;
                margin-top: 20px;
            }
        }

    }
}

/* 二维码弹窗样式 */
.qr-modal-content {
    text-align: center;
    padding: 20px;
    
    .qr-tips {
        margin-bottom: 15px;
        color: #666;
    }
    
    .qr-code-wrapper {
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }
    
    .qr-input {
        margin-top: 15px;
    }
}
</style>
